<template>
  <div class="container">
    <pfx-admin-menu />
    <div>
      <v-data-table :headers="headers" :pagination.sync="pagination" :items="tenants" must-sort hide-actions item-key="subdomain">
        <template slot="no-data">
          No tenants found
        </template>
        <template slot="items" slot-scope="props">
          <tr class="pointer" @click="viewTenant(props.item.subdomain)">
            <td>
              <div>
                <div>{{ props.item.subdomain }}</div>
                <div><small>{{ props.item.injected.domain }}</small></div>
              </div>
            </td>
            <td>
              <TenantStatusIndicator :tenant="props.item" />
            </td>
            <td>
              {{ props.item.created | prettyDateShort }}
            </td>
            <td>
              {{ props.item.injected.statistics.users }}
            </td>
            <td>
              {{ props.item.injected.statistics.closedAuctions }}
            </td>
            <td>
              {{ props.item.injected.statistics.totalAuctions }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
  import PfxAdminMenu from './PfxAdminMenu.vue'
  import TenantStatusIndicator from './elements/TenantStatusIndicator.vue'
  import { mapMutations } from 'vuex'

  export default {
    name: 'PfxAdminTenants',
    components: {
      PfxAdminMenu,
      TenantStatusIndicator
    },
    data() {
      return {
        pfxLandingPageUrl: process.env.config.frontend.pfxLandingPage,
        tenants: [],
        headers: [
          { text: 'Subdomain', align: 'left', value: 'subdomain' },
          { text: 'Status', align: 'left', value: 'status' },
          { text: 'Created', align: 'left', value: 'created' },
          { text: 'Users', align: 'left', value: 'injected.statistics.users' },
          { text: 'Closed auctions', align: 'left', value: 'injected.statistics.closedAuctions' },
          { text: 'Total auctions', align: 'left', value: 'injected.statistics.totalAuctions' }
        ],
        pagination: {
          sortBy: 'subdomain', descending: false, rowsPerPage: 100000000
        }
      }
    },
    created() {
      this.loadTenants()
    },
    methods: {
      ...mapMutations([
        'setLoadingSpinner',
        'openDialog'
      ]),

      loadTenants() {
        this.setLoadingSpinner(true)
        this.$PfxBackendApi.getPfxAdminTenants().then(res => {
          console.log('getPfxAdminTenants res', res)
          const tenants = res.data || []
          tenants.forEach(tenant => {
            tenant.injected = {}
            tenant.injected.domain = this.tenantDomain(tenant.subdomain)
            tenant.injected.statistics = {}

            this.$PfxBackendApi.getPfxAdminTenantStatistics(tenant.subdomain).then(res => {
              console.log('getPfxAdminTenantStatistics res', res)
              tenant.injected.statistics = res.data || {}
            }).catch(err => {
              console.error('getPfxAdminTenantStatistics err', err)
            })
          })
          this.tenants = tenants
        }).catch(err => {
          console.error('getPfxAdminTenants err', err)
          this.$notify({ type: 'danger', message: 'Unexpected error during loading tenants' })
          if (err.data.message) {
            this.$notify({ type: 'danger', message: err.data.message })
          }
        }).then(() => this.setLoadingSpinner(false))
      },

      tenantDomain(subdomain) {
        return this.pfxLandingPageUrl.replace(/\/\//, '//' + subdomain + '.')
      },

      viewTenant(subdomain) {
        this.$router.push('/pfxadmin/tenants/' + subdomain)
      }
    }
  }
</script>

<!--
<style lang="scss" scoped>
  @import 'node_modules/jeet/scss/index';
</style>
-->



// WEBPACK FOOTER //
// src/components/PfxAdminTenants.vue